export const Nav = (function () {
	'use strict';

	let $nav, $navIcon, $navTarget, $navChildren;
    
    function init() {
        $nav = $('.site-header__primary-nav');
        if(!$nav.length > 0) return null;
    
        $navIcon = $nav.find('.site-header__menu-icon');
        $navTarget = $nav.find('.site-header__nav-mobile');
        $navChildren = $navTarget.find('.menu-item-has-children');
        
    
        $navIcon.on('click', function(){
            let $this = $(this);
            if($this.hasClass('open')) {
                $this.removeClass('open');
                $navTarget.removeClass('show');
                $('body').removeClass('nav-open');
            } else {
                $this.addClass('open');
                $navTarget.addClass('show');
                $('body').addClass('nav-open');
            }
        });
    
        $navChildren.each(function(){
            let $child = $(this);
            $child.on('click', function(){
    
                if($(this).hasClass('active')){
                    $(this).removeClass('active').siblings().removeClass('active');
                } else {
                    $(this).addClass('active').siblings().removeClass('active');
                }
            })
        });
	}

	return {
		init: init,
	};
})();